import { render } from "./MyProject.vue?vue&type=template&id=478d887c&scoped=true"
import script from "./MyProject.vue?vue&type=script&lang=js"
export * from "./MyProject.vue?vue&type=script&lang=js"

import "./MyProject.vue?vue&type=style&index=0&id=478d887c&lang=sass&scoped=true"
import "./MyProject.vue?vue&type=style&index=1&id=478d887c&lang=sass"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478d887c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QScrollArea,QList,QItem,QItemSection,QAvatar,QTooltip,QCheckbox,QInnerLoading});qInstall(script, 'directives', {Ripple});
